module.exports = __webpack_public_path__ + "static/media/wallet-empty.4a3e4be3.svg";